// @flow

import _ from 'lodash';

import type { SubscriptionState, SubscriptionAction } from 'stores/flow-type/subscription.type';

import {
  VERIFY_DISCOUNT_CODE_REQUEST,
  VERIFY_DISCOUNT_CODE_SUCCESS,
  VERIFY_DISCOUNT_CODE_FAILURE,
  SUBSCRIBE_PLAN_REQUEST,
  SUBSCRIBE_PLAN_SUCCESS,
  SUBSCRIBE_PLAN_FAILURE,
  ACTIVATE_CHARGE_REQUEST,
  ACTIVATE_CHARGE_SUCCESS,
  ACTIVATE_CHARGE_FAILURE,
  CLEAR_DISCOUNT_CODE
} from 'stores/flow-type/subscription.type';

const initialState: SubscriptionState = {
  verifying: false,
  subscribing: false,
  activating: false,
  subscribeSuccess: false,
  success: false,
  error: undefined,
  percent: 0,
  termsConditions: '',
  confirmationUrl: undefined,
  migrateESCluster: false
};

const subscriptionReducers = (
  state: SubscriptionState = initialState,
  action: SubscriptionAction
) => {
  switch (action.type) {
    // Verify discount code
    case VERIFY_DISCOUNT_CODE_REQUEST:
      return { ...state, verifying: true };
    case VERIFY_DISCOUNT_CODE_SUCCESS: {
      const { data = {} } = action.payload;
      const discount = _.get(data, 'discount', {});
      let percent = _.get(data, 'discount.percent', 0);
      const discountType = _.get(data, 'discount.discountType', '');
      if (!_.isEmpty(discountType)) {
        percent = discountType === 'percentage' ? _.get(data, 'discount.discountValue', 0) : 0;
      }

      const termsConditions = _.get(data, 'termsConditions', '');

      return {
        ...state,
        verifying: false,
        error: undefined,
        percent,
        termsConditions,
        discount: discount
      };
    }
    case VERIFY_DISCOUNT_CODE_FAILURE:
      return {
        ...state,
        verifying: false,
        success: false,
        percent: 0,
        error: action.payload
      };

    // Clear discount code
    case CLEAR_DISCOUNT_CODE:
      return {
        ...state,
        percent: 0,
        discount: {},
        error: undefined
      };

    // Subscribe a plan
    case SUBSCRIBE_PLAN_REQUEST:
      return { ...state, subscribing: true, subscribeSuccess: false };
    case SUBSCRIBE_PLAN_SUCCESS: {
      const { data } = action.payload;
      const { confirmationUrl } = data;
      return {
        ...state,
        subscribing: false,
        subscribeSuccess: true,
        error: undefined,
        confirmationUrl
      };
    }
    case SUBSCRIBE_PLAN_FAILURE:
      return {
        ...state,
        subscribeSuccess: false,
        subscribing: false,
        success: false,
        error: action.payload
      };

    // Activate charge
    case ACTIVATE_CHARGE_REQUEST:
      return { ...state, activating: true, success: false };
    case ACTIVATE_CHARGE_SUCCESS: {
      const { data } = action.payload;

      const { message, migrateESCluster = false } = data;

      if (message === 'success') {
        return { ...state, activating: false, error: undefined, success: true, migrateESCluster };
      }

      return { ...state, activating: false, error: undefined, success: false, migrateESCluster };
    }
    case ACTIVATE_CHARGE_FAILURE:
      return {
        ...state,
        activating: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default subscriptionReducers;
